import React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    NumberInput,
    ReferenceInput,
    AutocompleteInput,
    required,
} from 'react-admin';
import { FormToolbar } from '../../common/FormToolbar';

export const ProductEdit = (props: any) => {
    const propsObj: any = { ...props };

    if (propsObj.permissions) {
        const resourcename = `/${props.resource}`;
        const myPermissions = propsObj.permissions.filter((item: any) => item.NavigateUrl.toLowerCase().trim() === resourcename);
        if (myPermissions.length > 0) {
            const p = myPermissions[0];
            propsObj.hasList = p.View === 1;
            propsObj.hasShow = p.View === 1;
            propsObj.hasEdit = p.Edit === 1;
            propsObj.hasDelete = p.Delete === 1;
            propsObj.hasCreate = p.Create === 1;
            propsObj.hasExport = p.Export === 1;
        }
    }

    return (
        <React.Fragment>
            <Edit title="Edit Product" {...propsObj} undoable={false}>
                <SimpleForm
                    warnWhenUnsavedChanges
                    redirect="list"
                    toolbar={<FormToolbar {...propsObj} />}
                    variant="outlined"
                >
                    <TextInput source="code" label="Code" fullWidth validate={[required()]}  disabled/>
                    <TextInput source="productName" label="Product Name" fullWidth validate={[required()]} />
                    <ReferenceInput
                        label="Product Group"
                        source="groupId"
                        reference="product-groups"
                        fullWidth
                    >
                        <AutocompleteInput
                            optionText="designName"
                            fullWidth
                            resettable
                        />
                    </ReferenceInput>
                    <NumberInput source="rate" label="Rate" fullWidth  />
                </SimpleForm>
            </Edit>
        </React.Fragment>
    );
};
